/**
 * @generated SignedSource<<efc2c74778d87c7d4ff71d5e9c5087c7>>
 * @relayHash b6d458351a73eb76a9bc4a94a606478d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4a620a02c247eb5242f85a2ce7eae170f41e40d4224e7f2b2ff79827f9efb2d1

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hubAri"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "hubAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v5 = {
      "kind": "InlineFragment",
      "selections": [{
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "name": "default"
        }]
      }, {
        "args": [{
          "fields": [{
            "items": [{
              "kind": "Variable",
              "name": "ids.0",
              "variableName": "pageAri"
            }],
            "kind": "ListValue",
            "name": "ids"
          }],
          "kind": "ObjectValue",
          "name": "filter"
        }],
        "concreteType": "HelpCenterPage",
        "kind": "LinkedField",
        "name": "pages",
        "plural": true,
        "selections": [v4 /*: any*/, {
          "concreteType": "HelpCenterPageLayout",
          "kind": "LinkedField",
          "name": "pageLayout",
          "plural": false,
          "selections": [{
            "concreteType": "HelpCenterLayoutAdf",
            "kind": "LinkedField",
            "name": "layoutAdf",
            "plural": false,
            "selections": [{
              "concreteType": "HelpCenterLayoutAdfContentConnection",
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [{
                "concreteType": "HelpCenterLayoutAdfContentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "concreteType": "HelpCenterLayoutAdfContent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "name": "content"
                  }]
                }]
              }]
            }]
          }]
        }]
      }],
      "type": "HelpCenter"
    },
    v6 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "message"
      }],
      "type": "QueryError"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v5 /*: any*/, v6 /*: any*/]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v5 /*: any*/, v6 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [v4 /*: any*/],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }]
    },
    "params": {
      "id": "4a620a02c247eb5242f85a2ce7eae170f41e40d4224e7f2b2ff79827f9efb2d1",
      "metadata": {},
      "name": "hubQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "6ac82d04e00aae5963faca158de58ce8";
export default node;